if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        galleryDeepZoomImage: null,
        productCursorDirection: 'next',
        productCursorIsFinePointer: false,
        productCursorInit() {
          this.productCursorIsFinePointer = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches;
          if (!settings.cursor_navigation || !this.productCursorIsFinePointer) return;
          this.$nextTick(() => {
            if (!this.$refs.mainSlider || !this.$refs.productCursorArrow) return;
            this.$refs.mainSlider.classList.add('is-product-cursor-navigation');
          });
        },
        productCursorInteractiveTarget(target) {
          return Boolean(target?.closest?.([
            'a',
            'input',
            'select',
            'textarea',
            'summary',
            'model-viewer',
            'video',
            'iframe',
            '.splide__arrow',
            '.button-play',
            '.x-product-media-share',
            '.product-media-zoom-icon',
            '.x-product-cursor-nav'
          ].join(',')));
        },
        productCursorMove(event) {
          if (!settings.cursor_navigation || !this.productCursorIsFinePointer || !this.$refs.mainSlider || !this.$refs.productCursorArrow) return;

          const bounds = this.$refs.mainSlider.getBoundingClientRect();
          const x = event.clientX - bounds.left;
          const y = event.clientY - bounds.top;
          const overUi = this.productCursorInteractiveTarget(event.target);

          this.productCursorDirection = x < bounds.width / 2 ? 'prev' : 'next';
          this.$refs.productCursorArrow.style.left = `${x}px`;
          this.$refs.productCursorArrow.style.top = `${y}px`;
          this.$refs.mainSlider.classList.toggle('is-product-cursor-prev', this.productCursorDirection === 'prev');
          this.$refs.mainSlider.classList.toggle('is-product-cursor-ready', !overUi);
          this.$refs.mainSlider.classList.toggle('is-product-cursor-over-ui', overUi);
        },
        productCursorLeave() {
          if (!this.$refs.mainSlider) return;
          this.$refs.mainSlider.classList.remove('is-product-cursor-ready', 'is-product-cursor-over-ui');
        },
        productCursorClick(event) {
          if (!settings.cursor_navigation || !this.productCursorIsFinePointer || this.productCursorInteractiveTarget(event.target)) return;

          const splide = this.$refs.mainSlider?.splide;
          if (!splide) return;

          event.preventDefault();
          event.stopPropagation();
          if (this.productCursorDirection === 'prev') {
            splide.go('<');
          } else {
            splide.go('>');
          }
        },
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        toggleGalleryDeepZoom(event) {
          const image = event.currentTarget;
          if (!image || !image.classList) return;

          if (this.galleryDeepZoomImage && this.galleryDeepZoomImage !== image) {
            this.resetGalleryDeepZoom();
          }

          image.classList.toggle('is-deep-zoomed');
          this.galleryDeepZoomImage = image.classList.contains('is-deep-zoomed') ? image : null;

          if (image.classList.contains('is-deep-zoomed')) {
            const zoomSrc = image.dataset.zoomSrc;
            if (zoomSrc && image.src !== zoomSrc) {
              image.dataset.originalSrc = image.src;
              image.src = zoomSrc;
            }
          } else if (image.dataset.originalSrc) {
            image.src = image.dataset.originalSrc;
            delete image.dataset.originalSrc;
          }

          this.galleryDeepZoomMove(event);
        },
        galleryDeepZoomMove(event) {
          const image = event.currentTarget;
          if (!image || !image.classList || !image.classList.contains('is-deep-zoomed')) return;

          const pointer = event.touches && event.touches.length ? event.touches[0] : event;
          const size = image.getBoundingClientRect();
          if (!size.width || !size.height || pointer.clientX === undefined || pointer.clientY === undefined) return;

          const x = ((pointer.clientX - size.left) / size.width) * 100;
          const y = ((pointer.clientY - size.top) / size.height) * 100;
          image.style.setProperty('--deep-zoom-x', `${Math.max(0, Math.min(100, x))}%`);
          image.style.setProperty('--deep-zoom-y', `${Math.max(0, Math.min(100, y))}%`);
        },
        galleryDeepZoomLeave(event) {
          this.galleryDeepZoomMove(event);
        },
        resetGalleryDeepZoom() {
          if (!this.galleryDeepZoomImage) return;

          this.galleryDeepZoomImage.classList.remove('is-deep-zoomed');
          this.galleryDeepZoomImage.style.removeProperty('--deep-zoom-x');
          this.galleryDeepZoomImage.style.removeProperty('--deep-zoom-y');
          if (this.galleryDeepZoomImage.dataset.originalSrc) {
            this.galleryDeepZoomImage.src = this.galleryDeepZoomImage.dataset.originalSrc;
            delete this.galleryDeepZoomImage.dataset.originalSrc;
          }
          this.galleryDeepZoomImage = null;
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        zoomOpen(position, isSplide) {
          this.resetGalleryDeepZoom();
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                splideEl.splide.refresh();
                const slides = Array.from(splideEl.splide.Components?.Elements?.slides || splideEl.querySelectorAll('.splide__slide'));
                slides.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  splideEl.splide.refresh();
                  const slides = Array.from(splideEl.splide.Components?.Elements?.slides || splideEl.querySelectorAll('.splide__slide'));
                  slides.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.resetGalleryDeepZoom();
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}
